import { Job } from '../types/interface';
import dayjs from 'dayjs';

function filterClosedJobs(job: Job) {
  const currentDate = dayjs();

  if (job.closeDate === null && job.isJobActive === false) {
    return false;
  }

  const isClosedWithinTwoWeeks = Math.abs(currentDate.diff(dayjs(job.closeDate), 'weeks')) <= 2;

  const isActiveWithNoClosingDate = job.isJobActive === true && job.closeDate === null;
  return isClosedWithinTwoWeeks || job.isJobActive === true || isActiveWithNoClosingDate;
}

export { filterClosedJobs };
